import React from "react"

export default class StringUtils {
    static stringFromUTF8Array(data) {
        const extraByteMap = [1, 1, 1, 1, 2, 2, 3, 0];
        var count = data.length;
        var str = "";

        for (var index = 0; index < count;) {
            var ch = data[index++];
            if (ch & 0x80) {
                var extra = extraByteMap[(ch >> 3) & 0x07];
                if (!(ch & 0x40) || !extra || ((index + extra) > count))
                    return null;

                ch = ch & (0x3F >> extra);
                for (; extra > 0; extra -= 1) {
                    var chx = data[index++];
                    if ((chx & 0xC0) !== 0x80)
                        return null;

                    ch = (ch << 6) | (chx & 0x3F);
                }
            }

            str += String.fromCharCode(ch);
        }

        return str;
    }

    // Check if element is not undefined or null
    static checkIfNotNull(field) {
        return (
            field === undefined ?
                ""
                :
                field === null ?
                    ""
                    :
                    field
        )
    }

    // Decodes Stream to Jspon
    static _buffer = "";
    static decodeJsonStreamingChunk(value) {
        const chunk = StringUtils.stringFromUTF8Array(value);
        this._buffer += chunk;

        const results = [];
        let depth = 0;
        let start = null;
        let inString = false;
        let escaped = false;

        for (let i = 0; i < this._buffer.length; i++) {
            const char = this._buffer[i];

            // Handle JSON string state
            if (inString) {
                if (escaped) {
                    escaped = false;
                } else if (char === '\\') {
                    escaped = true;
                } else if (char === '"') {
                    inString = false;
                }
                continue;
            }

            if (char === '"') {
                inString = true;
                continue;
            }

            if (char === '{') {
                if (depth === 0) {
                    start = i;
                }
                depth++;
            } else if (char === '}') {
                depth--;

                if (depth === 0 && start !== null) {
                    const jsonStr = this._buffer.slice(start, i + 1);

                    try {
                        results.push(JSON.parse(jsonStr));
                    } catch (e) {
                        console.error("JSON corrotto:", jsonStr);
                    }

                    start = null;
                }
            }
        }

        // Preserve incomplete JSON
        if (depth > 0 && start !== null) {
            this._buffer = this._buffer.slice(start);
        } else {
            this._buffer = "";
        }

        return results;
    }

    // Decodes Stream to Jspon
    static decodeJsonStreamingChunkFromString(value) {
        const byteString = value
        const preJSON = "[" + byteString.replace(/}{/g, '},{') + "]"
        try {
            return JSON.parse(preJSON)
        }
        catch (error) {
            console.error("SyntaxError: JSON.parse");
            return {}
        }
    }

    // Generates newlines in string for html
    static generateNewLines(text) {
        let result = text.split("\n").map((item, i) => {
            return <span key={i}>{item}<br /></span>
        })
        return result
    }



}